<template>
  <div
    :class="[bg || 'bg-white', padding || 'pt-24']"
    class="flex-none print:pt-0"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'FullWidth',
  props: {
    bg: {
      type: String,
      default: 'bg-white'
    },
    padding: {
      type: String,
      default: 'pt-24'
    }
  },
  mounted () {
    document.body.className = this.bg
  }
}
</script>

<style scoped>
</style>
